module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Italic.3d7cb865.ttf";